import axios from "axios";

export default axios.create({
  baseURL: "https://mediacenter.lpn.co.th/api/media/filetransfer",
  // baseURL: 'http://127.0.0.1:8000/api/parcel'
});
